module.exports = __webpack_public_path__ + "img/2f66916fa4f241ebb55b70595a3bbb12.2f66916f.png";